import { Button } from "../buttons/Button";
import { ButtonType } from "../buttons/ButtonType";
import { IconType } from "../../../constants";
import { ReactNode } from "react";
import classNames from "classnames";

export const SimpleFooter = (props: Props) => {
    const { onCancel, cancelLabel, cancelClass, onSubmit, submitIcon, cancelIcon, submitLabel, submitClass, submitButtonType, className, isSubmitDisabled, children } = props;

    return (
        <div className={classNames(className, children != null ? 'justify-between' : 'justify-end', 'flex justify-end items-center pb-4 pt-3')}>
            {children}
            <div className="inline-flex items-center">
                {onCancel && (
                    <Button
                        id="cancel-button"
                        onClick={onCancel}
                        buttonType={ButtonType.Link}
                        className={classNames("mr-2", cancelClass)}
                        Icon={cancelIcon}
                    >
                        {cancelLabel || 'Cancel'}
                    </Button>
                )}
                <Button
                    id="submit-button"
                    onClick={onSubmit}
                    buttonType={submitButtonType || ButtonType.Primary}
                    className={classNames(submitClass, 'ml-2')}
                    Icon={submitIcon}
                    disabled={isSubmitDisabled}
                >
                    {submitLabel || 'Submit'}
                </Button>
            </div>
        </div>
    );
};

export type Props = {
    children?: ReactNode;
    onCancel?: () => void;
    cancelLabel?: string;
    cancelIcon?: IconType;
    cancelClass?: string;
    onSubmit: () => void;
    submitLabel?: ReactNode;
    submitIcon?: IconType;
    submitButtonType?: ButtonType;
    submitClass?: string;
    isSubmitDisabled?: boolean;
    className?: string;
};